import * as _4 from 'lodash4';
import { ChoiceQuestionFunction } from '../../data/functions/choice_question_fn';
import { IGoal, ISurveyQuestionItemDTO } from '../../major_explorer_interface';

export class SurveyQuestionChoiceController {
  private mode: string;
  private item: ISurveyQuestionItemDTO;
  private delegateHandle: string;
  private validationCondition: { isValid: () => boolean };

  constructor(private $scope: ng.IScope, private choiceQuestionFn: ChoiceQuestionFunction) {}

  $onInit() {
    this.delegateHandle = this.item._parent.nk + 'second';
    this.choiceQuestionFn.initialize(this.item);
    this.validationCondition = {
      isValid: () => {
        return this.choiceQuestionFn.validate(this.item);
      }
    };
  }

  isOptionSelected(optionId: IGoal['id']): boolean {
    const selectedOption = _4.first(this.choiceQuestionFn.models._userSelected);

    return _4.get(selectedOption, 'id', undefined) === optionId;
  }

  updateOption(evt: any) {
    this.choiceQuestionFn.item_onChange(this.item, _4.toNumber(evt.detail.value) ? _4.toNumber(evt.detail.value) : -1);
  }

  // tslint:disable-next-line:no-empty
  save() {}
}

export class SurveyQuestionChoiceComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/survey_question_choice/survey_question_choice.html';
  public controller: any = SurveyQuestionChoiceController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    mode: '@',
    item: '='
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_question_choice/survey_question_choice_controller.ts